export const blobs=[
  {
    id: '00',
    english: '',
    yolngu: '',
    data: [{id:'00'}],
  },
  {
    id: '0',
    english: 'Child and family services at Galiwin’ku',
    subheading: 'Child and family services at Galiwin’ku',
    yolngu: '',
    bg:'#9855A0',
    data: [
      {
          animation: false,
          id:'2010', 
          colour:'white',
          english:'',
          yolngu:'',
          image:'babyhub',
          bg:'logoblob',
          audio:false,
          video:'https://www.youtube.com/shorts/C1CZatTMC2k'
        },
        {
          animation: false,
          id:'2012', 
          colour:'white',
          english:'',
          yolngu:'',
          image:'earc',
          bg:'logoblob',
          audio:false,
          video: 'https://youtu.be/Dh7rrj9cc1A'
          },
        {
          animation: false,
          id:'2013', 
          colour:'white',
          iconColour:'red',
          english:'',
          yolngu:'',
          image:'cb',
          bg:'logoblob',
          audio:true
          },
        {
          animation: false,
          id:'2022', 
          colour:'white',
          english:'',
          yolngu:'',
          image:'fast',
          bg:'logoblob',
          audio:false,
          video:'https://youtu.be/RDwx_VzNc04'
          },
        {
          animation: false,
          id:'2023', 
          colour:'white',
          english:'',
          yolngu:'',
          image:'yalu',
          bg:'logoblob',
          audio:false,
          link:'https://www.yalu.org.au/'
          },
        {
          animation: false,
          id:'2032', 
          colour:'white',
          iconColour:'red',
          english:'',
          yolngu:'',
          image:'loc',
          bg:'logoblob',
          audio:true
          }
      ],
  },
  {
    id: '1',
    english: 'Babies and toddlers',
    subheading: 'Ages 0 - 3.5 years',
    yolngu: '',
    bg:'#613366',
    data: [
        {
          animation: false,
          id:'2011', 
          colour:'white',
          english:'',
          yolngu:'',
          image:'faft',
          bg:'whiteblob',
          audio:true
          },
      ],
  },
  {
    id: '2',
    english: 'Preschool',
    subheading: '3.5 - 5 years',
    yolngu: '',
    bg:'#2185B9',
    data: [
      {
        animation: false,
        id:'2021', 
        colour:'blue',
        english:'Preschool',
        yolngu:'',
        bg:'lightblueblob',
        transparent:true,
        audio:true,
        style:{padding:80},
        fontStyle:{fontSize:32}
        },
      
    ],
  },
  {
    id: '4',
    english: 'Primary (Transition to Year 6)',
    subheading: 'About 5 - 12 years',
    yolngu: '',
    bg:'#42AD49',
    data: [
      {
        id:'ladder1',
        ladderClass:'blobLadderPrimary',
        ladder: [
          {
            animation: false,
            id:'2042', 
            colour:'green',
            english:'Year 1',
            yolngu:'',
            bg:'greenblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'20px', top:'10px'}
            },
          {
            animation: false,
            id:'2043', 
            colour:'green',
            english:'Year 2',
            yolngu:'',
            bg:'greenblob',
            transparent:true,
            audio:false
            },
          {
            animation: false,
            id:'2044', 
            colour:'green',
            english:'Year 3',
            yolngu:'',
            bg:'greenblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'-10px'}
            },
          {
            animation: false,
            id:'2045', 
            colour:'green',
            english:'Year 4',
            yolngu:'',
            bg:'greenblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'40px'}
            },
            {
              animation: false,
              id:'2052', 
              colour:'green',
              english:'Year 5',
              yolngu:'',
              bg:'greenblob',
              transparent:true,
              audio:false,
              style:{position:'relative', left:'20px'}
              },
            {
              animation: false,
              id:'2053', 
              colour:'green',
              english:'Year 6',
              yolngu:'',
              bg:'greenblob',
              transparent:true,
              audio:false,
              style:{position:'relative', left:'5px'}
              },
        ]
      },
      {
        id:'ladder10',
        ladder: [
          {
            animation: false,
            id:'2031', 
            colour:'aqua',
            english:'Transition',
            yolngu:'',
            bg:'lightaquablob',
            transparent:true,
            audio:true,
            style:{padding:80, position:'relative', top:'-200px', left:'-120px'},
            fontStyle:{fontSize:32}
            },
          {
            animation: false,
            id:'2041', 
            colour:'green',
            english:'Primary years',
            yolngu:'',
            bg:'lightgreenblob',
            transparent:true,
            audio:false,
            style:{padding:80},
            fontStyle:{fontSize:32}
            },
        
        ]
      },
      
    ],
  },
  {
    id: '5',
    english: 'Middle years (Year 7 to Year 9)',
    subheading: 'About 12 - 15 years',
    yolngu: '',
    bg:'#E9C935',
    data: [
      {
        animation: false,
        id:'2051', 
        colour:'yellow',
        english:'Middle years',
        yolngu:'',
        bg:'lightyellowblob',
        transparent:true,
        audio:false,
        style:{padding:80},
        fontStyle:{fontSize:32}
        },
      {
        id:'ladder2',
        ladderClass:'blobLadderMiddle',
        ladder: [
          
          {
            animation: false,
            id:'2054', 
            colour:'yellow',
            english:'Year 7',
            yolngu:'',
            bg:'yellowblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'20px'}
            },
            {
              animation: false,
              id:'2062', 
              colour:'yellow',
              english:'Year 8',
              yolngu:'',
              bg:'yellowblob',
              transparent:true,
              audio:false,
              style:{position:'relative', left:'10px', top:'-10px'}
              },
            {
              animation: false,
              id:'2063', 
              colour:'yellow',
              english:'Year 9',
              yolngu:'',
              bg:'yellowblob',
              transparent:true,
              audio:false,
              style:{position:'relative', left:'-40px', top:'0px'}
              },
        ]

      }
    ],
  },
  {
    id: '6',
    english: 'Senior years (Year 10 to Year 12)',
    subheading: 'About 15 - 18 years',
    yolngu: '',
    bg:'#EC9823',
    style:{paddingBottom:0},
    align:'center',
    data: [
      {
        id:'ladder3',
        ladderClass:'blobLadderSecondary',
        ladder: [
         
          {
            animation: false,
            id:'2064', 
            colour:'orange',
            english:'Year 10',
            yolngu:'',
            bg:'orangeblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'25px', top:'-20px'}
            },
          {
            animation: false,
            id:'2065', 
            colour:'orange',
            english:'Year 11',
            yolngu:'',
            bg:'orangeblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'80px', top:'-30px'}
            },
          {
            animation: false,
            id:'2066', 
            colour:'orange',
            english:'Year 12',
            yolngu:'',
            bg:'orangeblob',
            transparent:true,
            audio:false,
            style:{position:'relative', left:'80px', top:'-40px'}
            },
            {
              animation: false,
              id:'2096', 
              colour:'light',
              english:'NTCET',
              yolngu:'',
              bg:'transparent',
              transparent:true,
              audio:true,
              style:{position:'relative', left:'100px',top:'-60px', width:60, padding:20}
              },
        ]
      },
      {
        id:'ladder4',
        ladderClass:'blobLadderAtar',
        ladder: [
          {
            animation: false,
            id:'2061', 
            colour:'orange',
            english:'Senior years',
            yolngu:'',
            bg:'lightorangeblob',
            transparent:true,
            audio:false,
            style:{padding:80},
            fontStyle:{fontSize:32}
            },
            {
              animation: false,
              id:'2095', 
              colour:'light',
              english:'NTCET',
              yolngu:'',
              bg:'transparent',
              transparent:true,
              audio:true,
              style:{position:'relative', left:'-140px',top:'0px', width:60, padding:20}
              },
              {
                animation: false,
                id:'2067', 
                colour:'light',
                english:'ATAR',
                yolngu:'',
                bg:'transparent',
                transparent:true,
                audio:true,
                style:{position:'relative', left:'70px',top:'-40px', width:60, padding:20}
                },
        ]
      },
    ],
  },
  {
    id: '9',
    english:'',
    subheading:'',
    yolngu:'',
    bg:'#E75F64',
    style:{paddingTop:0, paddingBottom:0},
    data:[
      {
        id:'ladder9',
        ladderClass:'blobLadderTopRow',
        ladder:[
          {
            animation: false,
            id:'2094', 
            colour:'light',
            english:'Choosing a pathway',
            yolngu:'',
            bg:'transparent',
            transparent:true,
            audio:true,
            style:{position: 'relative', left:'-220px', top:'-50px'},
            },
            {
            animation: false,
            id:'2093', 
            colour:'red',
            english:'Tertiary education',
            yolngu:'',
            bg:'lightredblob',
            transparent:true,
            audio:true,
            style:{position: 'relative', left:'-140px' },
            fontStyle:{fontSize:26}
            }
        ]
      },
    ]
  },
  {
    id: '8',
    english:'',
    subheading:'',
    yolngu:'',
    bg:'#E75F64',
    style:{paddingTop:0, paddingBottom:0},
    data:[
      {
        id:'ladder7',
        ladderClass:'blobLadderTopLines',
        ladder:[
          
          {
            animation: false,
            id:'2091', 
            colour:'light',
            english:'Ŋaḻapaḻmirr Mala / Adults',
            yolngu:'',
            bg:'transparent',
            transparent:true,
            audio:false,
            fontStyle:{fontSize:24},
            style:{position:'relative', top: 50, padding: 20, width: 200, marginTop:0}
          },
          {
            animation: false,
            id:'2092', 
            colour:'light',
            english:'PTS',
            yolngu:'',
            bg:'transparent',
            transparent:true,
            audio:true,
            style:{padding: 10, width: 100, position:'relative', top: 55, }
          },
        ]
      },
    ]
  },
  {
    id: '15',
    english: '',
    subheading: '',
    yolngu: '',
    bg:'#E75F64',
    style:{paddingTop:0, marginTop:'-1px'},
    align:'top',
    audio:false,
    data: [
      {
        id:'ladder5',
        ladderClass:'blobLadderTopLineLeft',
        ladder: [
          {
            animation: false,
            id:'2071', 
            colour:'red',
            english:'VET / TAFE pathway',
            yolngu:'',
            bg:'lightredblob',
            transparent:true,
            audio:false,
            video:'https://youtu.be/hwmutKojM9k',
            style:{padding:60},
            fontStyle:{fontSize:26}
            },
            {
              animation: false,
              id:'2081', 
              colour:'red',
              english:'Certificate 1',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'2082', 
              colour:'red',
              english:'Certificate 2',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'2083', 
              colour:'red',
              english:'Certificate 3',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'2084', 
              colour:'red',
              english:'Certificate 4',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'2085', 
              colour:'red',
              english:'Diploma',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'2086', 
              colour:'red',
              english:'Advanced Diploma / Associate Degree',
              yolngu:'',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
        ]
      },
      
      {
        id:'ladder6',
        ladderClass:'blobLadderTopLineRight',
        ladder: [
          {
            animation: false,
            id:'2087', 
            colour:'red',
            english:'Higher Education pathway University degrees',
            yolngu:'',
            bg:'lightredblob',
            transparent:true,
            audio:false,
            video:'https://youtu.be/ZZkF4oju8BQ',
            style:{padding:60, position:'relative', left:'-60px', top:'-20px'},
            fontStyle:{fontSize:26}
            },
            {
              animation: false,
              id:'2088', 
              colour:'red',
              english:'Bachelor Degree',
              yolngu:'',
              bg:'lightpinkblob',
              transparent:true,
              audio:false,
              style:{},
              fontStyle:{}
            },
            {
              animation: false,
              id:'2088', 
              colour:'red',
              english:'Honours Degree',
              yolngu:'',
              bg:'pinkblob',
              transparent:true,
              audio:false,
              style:{},
              fontStyle:{}
            },
            {
              animation: false,
              id:'2089', 
              colour:'red',
              english:'Master Degree',
              yolngu:'',
              bg:'darkpinkblob',
              transparent:true,
              audio:false,
              style:{},
              fontStyle:{}
            },
            {
              animation: false,
              id:'2090', 
              colour:'red',
              english:'Doctorate Degree e.g. PHD',
              yolngu:'',
              bg:'verydarkpinkblob',
              transparent:true,
              audio:false,
              style:{},
              fontStyle:{}
            },
        ]
      },
      
    ],
  },
  {
    id: '16',
    english: '',
    subheading: '',
    yolngu: '',
    bg:'#E75F64',
    style:{paddingTop:0, marginTop:'-1px'},
    align:'top',
    audio:false,
    data: [
      {
        id:'ladder5',
        ladderClass:'blobLadderTopLineLeft',
        ladder: [
          {
            animation: false,
            id:'20711', 
            colour:'red',
            english:'Stories from Yolŋu students',
            yolngu:'',
            bg:'lightredblob',
            transparent:true,
            audio:false,
            video:'',
            style:{padding:60},
            fontStyle:{fontSize:26}
            },
            {
              animation: false,
              id:'20811', 
              colour:'red',
              english:'Stuart Yiwarr',
              yolngu:'',
              audio:false,
              video:'https://youtu.be/YQsTG9JORSI',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'20821', 
              colour:'red',
              english:'Dikul Baker',
              yolngu:'',
              audio:false,
              video:'https://youtu.be/dy6B0K6We1Q',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
            {
              animation: false,
              id:'20831', 
              colour:'red',
              english:'Sheena Bawu',
              yolngu:'',
              audio:false,
              video:'https://youtu.be/7gVVDKbgZFI',
              bg:'redblob',
              transparent:true,
              audio:false,
            },
        ]
      }, 
    ],
  }
];